export enum ProjectReducerType {
  ACTIVE_PROJECTS = 'active_projects',
  PROJECTS = 'projects'
}
